/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cash_Balance_Stripe_ErrorInputs */

const en_cash_balance_stripe_error = /** @type {(inputs: Cash_Balance_Stripe_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You have a cash balance in your Stripe account. Please contact Brave Support for assistance with deleting your account.`)
};

const id_cash_balance_stripe_error = /** @type {(inputs: Cash_Balance_Stripe_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda memiliki saldo tunai di akun Stripe. Hubungi Dukungan Brave untuk bantuan dalam menghapus akun Anda.`)
};

const ms_cash_balance_stripe_error = /** @type {(inputs: Cash_Balance_Stripe_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda mempunyai baki tunai dalam akaun Stripe anda. Sila hubungi Brave Support untuk bantuan memadamkan akaun anda.`)
};

const ca_cash_balance_stripe_error = /** @type {(inputs: Cash_Balance_Stripe_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tens saldo disponible al teu compte de Stripe. Posa't en contacte amb el servei d'assistència de Brave per eliminar el teu compte.`)
};

const cs_cash_balance_stripe_error = /** @type {(inputs: Cash_Balance_Stripe_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na účtu Stripe máte peněžní zůstatek. O pomoc s odstraněním účtu požádejte podporu Brave.`)
};

const da_cash_balance_stripe_error = /** @type {(inputs: Cash_Balance_Stripe_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du har en kontant saldo på din Stripe-konto. Kontakt Braves kundeservice for at få hjælp til at slette din konto.`)
};

const de_cash_balance_stripe_error = /** @type {(inputs: Cash_Balance_Stripe_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du hast noch Guthaben auf deinem Stripe-Konto. Bitte wende dich an den Brave Support, wenn du Hilfe beim Löschen deines Kontos brauchst.`)
};

const et_cash_balance_stripe_error = /** @type {(inputs: Cash_Balance_Stripe_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teie Stripe'i kontol on sularahajääk. Võtke ühendust Brave'i klienditoega, et saada abi oma konto kustutamisel.`)
};

const es_cash_balance_stripe_error = /** @type {(inputs: Cash_Balance_Stripe_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tienes saldo en tu cuenta de Stripe. Comunícate con el equipo de Soporte de Brave para obtener asistencia para eliminar tu cuenta.`)
};

const fr_cash_balance_stripe_error = /** @type {(inputs: Cash_Balance_Stripe_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre solde Stripe n’est pas nul. Veuillez contacter l’assistance Brave pour obtenir de l’aide.`)
};

const hr_cash_balance_stripe_error = /** @type {(inputs: Cash_Balance_Stripe_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Još imate gotovine na računu Stripe. Ako vam treba pomoć vezano uz brisanje računa, obratite se podršci Brave.`)
};

const it_cash_balance_stripe_error = /** @type {(inputs: Cash_Balance_Stripe_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai un conto attivo nel tuo account Stripe. Contatta l'Assistenza Brave per ricevere supporto ed eliminare il tuo account.`)
};

const lv_cash_balance_stripe_error = /** @type {(inputs: Cash_Balance_Stripe_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jūsu Stripe kontā ir naudas atlikums. Lūdzu, sazinieties ar Brave atbalsta dienestu, lai saņemtu palīdzību par konta dzēšanu.`)
};

const lt_cash_balance_stripe_error = /** @type {(inputs: Cash_Balance_Stripe_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`„Stripe“ paskyroje turite pinigų likutį. Susisiekite su „Brave“ palaikymo komanda, kad padėtų ištrinti paskyrą.`)
};

const hu_cash_balance_stripe_error = /** @type {(inputs: Cash_Balance_Stripe_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe-egyenlege még nem üres. A fiók törléséhez kérjük, lépjen kapcsolatba a Brave ügyfélszolgálattal.`)
};

const nl_cash_balance_stripe_error = /** @type {(inputs: Cash_Balance_Stripe_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je hebt nog saldo in je Stripe-account. Neem contact op met Brave Support voor hulp bij de verwijdering van uw account.`)
};

const nb_cash_balance_stripe_error = /** @type {(inputs: Cash_Balance_Stripe_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du har en utestående saldo på Stripe-kontoen din. Ta kontakt med Braves brukerstøtte for å få hjelp til å slette kontoen din.`)
};

const pl_cash_balance_stripe_error = /** @type {(inputs: Cash_Balance_Stripe_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masz saldo gotówkowe na koncie Stripe. Skontaktuj się z pomocą techniczną Brave, aby uzyskać wsparcie w usunięciu konta.`)
};

const pt_cash_balance_stripe_error = /** @type {(inputs: Cash_Balance_Stripe_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você possui um saldo em dinheiro em sua conta do Stripe. Por favor, entre em contato com o Suporte Brave para obter ajuda na exclusão de sua conta.`)
};

const ro_cash_balance_stripe_error = /** @type {(inputs: Cash_Balance_Stripe_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ai un sold de numerar în contul tău Stripe. Te rugăm să contactezi Asistența Brave pentru asistență cu privire la ștergerea contului tău.`)
};

const sk_cash_balance_stripe_error = /** @type {(inputs: Cash_Balance_Stripe_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na účte Stripe máte peňažný zostatok. Obráťte sa na podporu Brave, ktorá vám pomôže s vymazaním vášho účtu.`)
};

const sl_cash_balance_stripe_error = /** @type {(inputs: Cash_Balance_Stripe_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na računu Stripe imate denarna sredstva. Za pomoč pri brisanju računa se obrnite na Podporo podjetja Brave.`)
};

const fi_cash_balance_stripe_error = /** @type {(inputs: Cash_Balance_Stripe_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinulla on käteissaldo Stripe-tililläsi. Ota yhteyttä Brave-tukeen saadaksesi apua tilisi poistamisessa.`)
};

const sv_cash_balance_stripe_error = /** @type {(inputs: Cash_Balance_Stripe_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du har ett kassasaldo på ditt Stripe-konto. Kontakta Brave-support för att få hjälp med att radera ditt konto.`)
};

const vi_cash_balance_stripe_error = /** @type {(inputs: Cash_Balance_Stripe_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn có số dư tiền mặt trong tài khoản Stripe của mình. Vui lòng liên hệ với bộ phận Hỗ trợ của Brave để được hỗ trợ trong việc xóa tài khoản.`)
};

const tr_cash_balance_stripe_error = /** @type {(inputs: Cash_Balance_Stripe_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe hesabınızda nakit bakiyeniz var. Hesabınızı silme konusunda yardım almak için lütfen Brave Destek ile iletişime geçin.`)
};

const el_cash_balance_stripe_error = /** @type {(inputs: Cash_Balance_Stripe_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Έχετε υπόλοιπο μετρητών στο Stripe λογαριασμό σας. Επικοινωνήστε με την υποστήριξη της Brave για βοήθεια σχετικά με τη διαγραφή του λογαριασμού σας.`)
};

const bg_cash_balance_stripe_error = /** @type {(inputs: Cash_Balance_Stripe_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имаш паричен баланс по своя акаунт в Stripe. Моля, свържи се с поддръжката на Brave за съдействие при изтриването на акаунта ти.`)
};

const ru_cash_balance_stripe_error = /** @type {(inputs: Cash_Balance_Stripe_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`На вашем аккаунте в Stripe есть наличные средства. Обратитесь в службу поддержки Brave Support за помощью в удалении вашего аккаунта.`)
};

const sr_cash_balance_stripe_error = /** @type {(inputs: Cash_Balance_Stripe_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имате готовински износ на свом налогу на Stripe-у. Ако вам је потребна помоћ око брисања налога обратите се Brave подршци.`)
};

const uk_cash_balance_stripe_error = /** @type {(inputs: Cash_Balance_Stripe_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`У вас є залишок коштів на рахунку Stripe. Зверніться до служби підтримки Brave за допомогою у видаленні акаунта.`)
};

const ka_cash_balance_stripe_error = /** @type {(inputs: Cash_Balance_Stripe_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`თქვენი Stripe-ს ანგარიშზე ბალანსია დარჩენილი. ანგარიშის წაშლასთან დაკავშირებით, გთხოვთ, მიმართოთ Brave-ის მხარდაჭერის გუნდს.`)
};

const hi_cash_balance_stripe_error = /** @type {(inputs: Cash_Balance_Stripe_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपके स्ट्राइप अकाउंट में कॅश बैलेंस है।अपना अकाउंट डिलीट करने में मदद के लिए कृपया ब्रेव सपोर्ट से संपर्क करें।`)
};

const th_cash_balance_stripe_error = /** @type {(inputs: Cash_Balance_Stripe_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณมียอดเงินสดคงเหลือในบัญชี Stripe ของคุณ ติดต่อฝ่ายสนับสนุนของ Brave เพื่อขอความช่วยเหลือในการลบบัญชีของคุณ`)
};

const ko_cash_balance_stripe_error = /** @type {(inputs: Cash_Balance_Stripe_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe 계정에 현금 잔액이 있습니다. 계정 삭제에 대한 도움이 필요하면 Brave 지원팀에 문의하세요.`)
};

const zh_cash_balance_stripe_error = /** @type {(inputs: Cash_Balance_Stripe_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的 Stripe 账户中有现金余额。请联系 Brave 支持获取删除账户方面的帮助。`)
};

const zh_tw_cash_balance_stripe_error = /** @type {(inputs: Cash_Balance_Stripe_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的 Stripe 帳戶內尚有現金餘額。如需協助刪除帳戶，請聯絡 Brave 支援團隊。`)
};

const ja_cash_balance_stripe_error = /** @type {(inputs: Cash_Balance_Stripe_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなたのStripeアカウントに現金残高があります。アカウントを削除する際は、Braveサポートに連絡してサポートを受けてください。`)
};

/**
* | output |
* | --- |
* | "You have a cash balance in your Stripe account. Please contact Brave Support for assistance with deleting your account." |
*
* @param {Cash_Balance_Stripe_ErrorInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const cash_balance_stripe_error = /** @type {((inputs?: Cash_Balance_Stripe_ErrorInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cash_Balance_Stripe_ErrorInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cash_balance_stripe_error(inputs)
	if (locale === "ms") return ms_cash_balance_stripe_error(inputs)
	if (locale === "ca") return ca_cash_balance_stripe_error(inputs)
	if (locale === "cs") return cs_cash_balance_stripe_error(inputs)
	if (locale === "da") return da_cash_balance_stripe_error(inputs)
	if (locale === "de") return de_cash_balance_stripe_error(inputs)
	if (locale === "et") return et_cash_balance_stripe_error(inputs)
	if (locale === "es") return es_cash_balance_stripe_error(inputs)
	if (locale === "fr") return fr_cash_balance_stripe_error(inputs)
	if (locale === "hr") return hr_cash_balance_stripe_error(inputs)
	if (locale === "it") return it_cash_balance_stripe_error(inputs)
	if (locale === "lv") return lv_cash_balance_stripe_error(inputs)
	if (locale === "lt") return lt_cash_balance_stripe_error(inputs)
	if (locale === "hu") return hu_cash_balance_stripe_error(inputs)
	if (locale === "nl") return nl_cash_balance_stripe_error(inputs)
	if (locale === "nb") return nb_cash_balance_stripe_error(inputs)
	if (locale === "pl") return pl_cash_balance_stripe_error(inputs)
	if (locale === "pt") return pt_cash_balance_stripe_error(inputs)
	if (locale === "ro") return ro_cash_balance_stripe_error(inputs)
	if (locale === "sk") return sk_cash_balance_stripe_error(inputs)
	if (locale === "sl") return sl_cash_balance_stripe_error(inputs)
	if (locale === "fi") return fi_cash_balance_stripe_error(inputs)
	if (locale === "sv") return sv_cash_balance_stripe_error(inputs)
	if (locale === "vi") return vi_cash_balance_stripe_error(inputs)
	if (locale === "tr") return tr_cash_balance_stripe_error(inputs)
	if (locale === "el") return el_cash_balance_stripe_error(inputs)
	if (locale === "bg") return bg_cash_balance_stripe_error(inputs)
	if (locale === "ru") return ru_cash_balance_stripe_error(inputs)
	if (locale === "sr") return sr_cash_balance_stripe_error(inputs)
	if (locale === "uk") return uk_cash_balance_stripe_error(inputs)
	if (locale === "ka") return ka_cash_balance_stripe_error(inputs)
	if (locale === "hi") return hi_cash_balance_stripe_error(inputs)
	if (locale === "th") return th_cash_balance_stripe_error(inputs)
	if (locale === "ko") return ko_cash_balance_stripe_error(inputs)
	if (locale === "zh") return zh_cash_balance_stripe_error(inputs)
	if (locale === "zh-tw") return zh_tw_cash_balance_stripe_error(inputs)
	if (locale === "ja") return ja_cash_balance_stripe_error(inputs)
	return en_cash_balance_stripe_error(inputs)
});